// extracted by css-extract-rspack-plugin
export default {"container":"gMESb3W7CgPRwbEZ","error":"POLw9tSb8k8Gq2zR"};